import SourceList from './SourceList';
import SourceEdit from './SourceEdit';

export default {
  name: 'whatsapp_message_source',
  list: SourceList,
  edit: SourceEdit,
};
